<template>
    <div>
        <div class="">
            <div class="flex flex-col pb-3">
                <div class="flex flex-col">
                    <Field field_name="Sconto in percentuale" v-model="scontoModel" placeholder="Sconto" type="number"
                           :input-attrs="{step:0.01,min:0, max:100}" :errors="[error]">
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex justify-end gap-3 pt-5">
            <NextButton variant="outline-secondary"
                        @click="$emit('chiudi')"
                        class="w-44 py-2 px-4">
                Chiudi
            </NextButton>
            <NextButton variant="primary" :disabled="$attrs.waiting"
                        @click="save"
                        class="w-44 py-2 px-4">
                Salva
            </NextButton>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";


@Options({
    name: 'Sconto',
    components: {
        Field,
        NextButton,
        MultiselectOption
    },
    props: {
        sconto: [Number,String]
    }
})
export default class Sconto extends Vue {

    sconto!: number

    scontoModel!: number
    error = ""

    init() {
        this.scontoModel = this.sconto
    }


    created() {
        this.init()
    }

    validate() {
        if (this.scontoModel > 100 || this.scontoModel < 0) {
            this.error = " Il valore deve essere compreso fra 0 e 100"
            return false
        }
        return true
    }

    save() {
        if (this.validate()) {
            this.$emit('update:waiting', true)
            //@ts-ignore
            this.$emit('update:sconto', this.scontoModel)
            this.$nextTick(() => {
                this.$emit('save')
            })
        }
    }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
